module.exports = __webpack_public_path__ + "img/login_cn.260f9006.svg";